import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { FamilyHistoryModel } from '../models/FamilyHistoryModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class FamilyHistoryService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getFamilyHistory(patientCode: string , compcode: string) {

      let params = new HttpParams();
        params = params.append("PatientCode", patientCode);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<FamilyHistoryModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/FamilyHistory/GetFamilyHistory',options);
    }


    public AddFamilyHistory(SHistory: FamilyHistoryModel) {
      return this.http.post<FamilyHistoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/FamilyHistory/AddFamilyHistory', SHistory);
    }

    public delFamilyHistory(id: string, compcode: string) {

    let params = new HttpParams();
    params = params.append("ID", id);
 
    params = params.append("CompCode", compcode);


      const options = {
        params: params
    };
    return this.http.get<FamilyHistoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/FamilyHistory/DeleteFamilyHistory',options);
    }

  }
